import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './FileUploader.css';

const FileUploader = ({ onFilesSelected, disabled }) => {
  const onDrop = useCallback(onFilesSelected, [onFilesSelected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.heic', '.heif', '.webp']
    },
    onDropRejected: (rejectedFiles) => {
      const rejectedFileNames = rejectedFiles.map(f => f.file.name).join(', ');
      alert(`The following files were rejected because they are not supported image formats: ${rejectedFileNames}\n\nSupported formats: JPG, PNG, GIF, HEIC, HEIF, WebP`);
    }
  });

  return (
    <div {...getRootProps()} className={`file-uploader ${isDragActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
      <input {...getInputProps()} />
      {
        isDragActive ?
          <p>Drop the files here ...</p> :
          <p>Drag and drop some files here, or click to select files</p>
      }
    </div>
  );
};

export default FileUploader;